import React from 'react'
import Select from '@/Shared/Form/Select';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { countries } from 'countries-list';
import { isEUandEEACountryCodes } from '@/lib/settings';

const CountriesSelect = () => {
  const {formState: { errors } } = useFormContext();
  const nonEUandEEACountries = Object.keys(countries).filter(country => !isEUandEEACountryCodes.has(country));
  const options = nonEUandEEACountries.map(country => ({
    ...countries[country],
    code: country,
  }));
  
  return (
    <div className='mt-3'>
      <label className='form-label required'>Select countries</label>
      <Select
        isRequired
        labelText='Country'
        name='thirdPartyCountries'
        options={options}
        isMulti={true}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option}
        getOptionEqual={(option) => option.code}
      />
      <ErrorMessage
        errors={errors}
        name='thirdPartyCountries'
        render={({ message }) => (
          <small className='text-danger'>
            {message}
          </small>
        )}
      />
    </div>
  )
}

export default CountriesSelect